import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { StaticFields } from "@graylog/server-api";
import { BootstrapModalForm, Input } from "components/bootstrap";
import UserNotification from "util/UserNotification";
import { KEY_PREFIX } from "hooks/usePaginatedInputs";
const StaticFieldForm = ({ input, setShowModal }) => {
  const { t } = useTranslation("inputs");
  const [fieldName, setFieldName] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const queryClient = useQueryClient();
  const addStaticField = () => {
    StaticFields.create(input.id, { key: fieldName, value: fieldValue }).then(
      () => {
        UserNotification.success(t("static_fields.add_success", { field: fieldName, input: input.title }));
        setShowModal(false);
        queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
      },
      (error) => {
        UserNotification.error(
          t("static_fields.add_failed", { error }),
          t("static_fields.add_failed_title", { input: input.title })
        );
      }
    );
  };
  const handleFieldChange = (name, event) => {
    const { value } = event.target;
    if (name === "name") {
      setFieldName(value);
    }
    if (name === "value") {
      setFieldValue(value);
    }
  };
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      title: t("static_fields.add"),
      submitButtonText: t("static_fields.add_field"),
      onCancel: () => {
        setShowModal(false);
      },
      onSubmitForm: addStaticField
    },
    /* @__PURE__ */ React.createElement("p", null, t("static_fields.description")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        value: fieldName,
        onChange: (event) => {
          handleFieldChange("name", event);
        },
        id: "field-name",
        label: t("static_fields.field_name"),
        required: true,
        pattern: "[A-Za-z0-9_]*",
        title: t("static_fields.field_name_title")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        value: fieldValue,
        onChange: (event) => {
          handleFieldChange("value", event);
        },
        type: "text",
        id: "field-value",
        label: t("static_fields.field_value"),
        required: true
      }
    )
  );
};
export default StaticFieldForm;
